import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta19Model } from './model-consultaSeguimentoPergunta19'

export const PERGUNTA_19_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta19Model> = {
  PERGUNTA_19_HEADER: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO',
      },
    ],
  },
  PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA',
      },
    ],
    dependsOn: 'PERGUNTA_19_HEADER',
  },
  PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO',
      },
    ],
    dependsOn: 'PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO',
  },
  PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA',
  },
}
